/**
 * Skeleton for the course detail page: hero + sidebar + content blocks.
 */
export function CourseDetailSkeleton() {
  return (
    <div className="relative overflow-hidden animate-pulse">
      <section className="py-12 md:py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="h-4 w-40 bg-muted rounded mb-6" />
          <div className="grid md:grid-cols-3 gap-8">
            <div className="md:col-span-2 space-y-4">
              <div className="h-6 w-24 bg-muted rounded-full" />
              <div className="h-10 w-4/5 bg-muted rounded" />
              <div className="h-5 w-full bg-muted rounded" />
              <div className="h-5 w-3/4 bg-muted rounded" />
              <div className="flex gap-6 mt-6">
                <div className="h-4 w-24 bg-muted rounded" />
                <div className="h-4 w-16 bg-muted rounded" />
                <div className="h-4 w-28 bg-muted rounded" />
              </div>
            </div>
            <div className="bg-card border border-border rounded-2xl p-6 space-y-4 h-fit">
              <div className="h-8 w-24 bg-muted rounded mx-auto" />
              <div className="h-4 w-28 bg-muted rounded mx-auto" />
              <div className="h-12 w-full bg-muted rounded-xl" />
              <div className="h-3 w-full bg-muted rounded" />
            </div>
          </div>
        </div>
      </section>
      <section className="py-12 px-6 border-t border-border">
        <div className="max-w-6xl mx-auto space-y-6">
          <div className="h-7 w-40 bg-muted rounded" />
          <div className="h-4 w-full bg-muted rounded" />
          <div className="h-4 w-5/6 bg-muted rounded" />
        </div>
      </section>
      <section className="py-12 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="h-4 w-32 bg-muted rounded mb-4" />
        </div>
      </section>
    </div>
  );
}
